"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckFields = void 0;
function CheckFields(objectWithFields, fields) {
    return fields.filter(f => (typeof objectWithFields[f] === "number" ? false : !objectWithFields[f]));
}
exports.CheckFields = CheckFields;
//# sourceMappingURL=CheckFields.js.map